/**
 * Hosts canónicos de la plataforma. Cualquier otro hostname se considera un
 * dominio personalizado de un restaurante.
 */
const CANONICAL_HOSTS = [
  'pidelonuestro.com',
  'www.pidelonuestro.com',
  'dev-pidelonuestro.hmdevs.com',
  'localhost',
  '127.0.0.1'
];

/** True si el hostname NO es canónico (= dominio personalizado de un restaurante). */
export function isCustomDomainHost(hostname: string): boolean {
  const host = (hostname || '').toLowerCase().split(':')[0];
  if (!host) {
    return false;
  }
  // IPs (ej. 93.127.142.154) no son dominios custom.
  if (/^\d{1,3}(\.\d{1,3}){3}$/.test(host)) {
    return false;
  }
  return !CANONICAL_HOSTS.includes(host);
}
